  document.addEventListener('DOMContentLoaded', function() {
    const wrappers = document.querySelectorAll('.product-thumbnails-wrapper--carousel');

    wrappers.forEach(function(wrapper) {
      const container = wrapper.querySelector('.product-thumbnails--carousel');
      const prevBtn = wrapper.querySelector('[data-thumbnails-prev]');
      const nextBtn = wrapper.querySelector('[data-thumbnails-next]');

      if (!container || !prevBtn || !nextBtn) return;

      const thumbBtns = container.querySelectorAll('[data-product-thumbnail]');
      const totalItems = thumbBtns.length;
      if (totalItems <= 1) return; 

      function getActiveIndex() {
        let activeIndex = 0;
        thumbBtns.forEach((btn, index) => {
          if (btn.classList.contains('active')) {
            activeIndex = index;
          }
        });
        return activeIndex;
      }

      function goToIndex(index) {
        index = (index + totalItems) % totalItems;

        const targetItem = thumbBtns[index].closest('.product-thumbnails__item--carousel');
        if (!targetItem) return;

        const containerWidth = container.clientWidth;
        const itemWidth = targetItem.offsetWidth + 10;
        const scrollPosition = targetItem.offsetLeft - (containerWidth / 2) + (itemWidth / 2);
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });

        thumbBtns[index].click();
      }

      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentIndex = getActiveIndex();
        const nextIndex = (currentIndex + 1) % totalItems;
        goToIndex(nextIndex);
      });

      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentIndex = getActiveIndex();
        const prevIndex = (currentIndex - 1 + totalItems) % totalItems;
        goToIndex(prevIndex);
      });

      thumbBtns.forEach((btn, index) => {
        btn.addEventListener('click', function() {
          
          setTimeout(() => {
            const activeIndex = getActiveIndex();
            const targetItem = thumbBtns[activeIndex].closest('.product-thumbnails__item--carousel');
            if (targetItem) {
              const containerWidth = container.clientWidth;
              const itemWidth = targetItem.offsetWidth + 10;
              const scrollPosition = targetItem.offsetLeft - (containerWidth / 2) + (itemWidth / 2);
              container.scrollTo({
                left: scrollPosition,
                behavior: 'smooth'
              });
            }
          }, 50);
        });
      });

      setTimeout(() => {
        const initialIndex = getActiveIndex();
        const targetItem = thumbBtns[initialIndex].closest('.product-thumbnails__item--carousel');
        if (targetItem) {
          const containerWidth = container.clientWidth;
          const itemWidth = targetItem.offsetWidth + 10;
          const scrollPosition = targetItem.offsetLeft - (containerWidth / 2) + (itemWidth / 2);
          container.scrollTo({
            left: scrollPosition,
            behavior: 'auto' 
          });
        }
      }, 100);
    });
  });